import Desktop from "@/components/Desktop";
import MobileGame from "@/components/MobileGame";
import { IGameType, VideoQualityType } from "@/types/GlobalTypes";
import { isNullOrEmpty } from "./commonMobile";

function getStreamingLink(game: IGameType, quality: VideoQualityType) {
	// console.log("hSL", quality, game.stream_hd);

	return quality === "hd" &&
		!isNullOrEmpty(game.stream_hd) &&
		game.stream_hd !== "-"
		? game.stream_hd
		: game.stream;
}

function hasHDStreaming(game: IGameType) {
	return !isNullOrEmpty(game.stream_hd);
}

/**
 * From toggle button
 */
function changeVideoQuality() {
	const currentQuality = (this as Desktop | MobileGame).state.activeVideoQuality;
	this.setState({
		activeVideoQuality:
			currentQuality === "hd" ?
				"sd" : "hd"
	}, () => {
		this.reloadStreaming();
	});
}

/**
 * from select option in Settings
 */
function updateVideoQuality(e: any) {
	const newQuality = e.currentTarget.value;

	this.setState({
		activeVideoQuality: newQuality
	}, () => {
		this.reloadStreaming();
	});
}

export {
	getStreamingLink,
	hasHDStreaming,
	changeVideoQuality,
	updateVideoQuality
}